<template>
  <div class="blog-container">
    <div class="blog-post-header d-flex justify-content-center">
      <h1 id="page-title">NEW + NOW</h1>
    </div>

    <div class="container">
      <div class="row">
        <section v-if="isDesktop" class="side-nav col-xl-3" aria-labelledby="sidebar-title">
          <h2 id="sidebar-title" class="visually-hidden">Blog Navigation</h2>
          <BlogSideBar :blogHomeOnly="true"></BlogSideBar>
        </section>

        <section class="blog-content col-xl-9" aria-labelledby="page-title">
          <FroalaContent
            v-if="currentPage && currentPage[0].body"
            :html="currentPage[0].body"
            :postDetails="currentPage[0]"
          />
        </section>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useMainStore } from '~/store';
import BlogSideBar from '@/components/BlogSideBar.vue';
import FroalaContent from '@/components/FroalaContent.vue';
import _isEmpty from 'lodash/isEmpty';

const store = useMainStore();
const route = useRoute();
const router = useRouter();
const { isMobile, isDesktop } = useMobileChecker();
const { loadSeo, findPageBySlug, loadPageData, timezone, findBlogByName } = store;
const currentSlug = route.params.slug;

/* ASYNC DATA */
const currentPage = await useCurrentPage(currentSlug, "blog-post");

if (!currentPage || _isEmpty(currentPage[0])) {
  router.push('/new-now/'); 
}

/* SEO */
const currentSEO = await useSeo(`/posts/${currentSlug}`);
useHead(currentSEO.value); // Required for seo to work

const categories = await $fetch(`${store.baseURL}/get_model_categories?model_type=Blog`);

if (currentPage?.[0]?.categories?.length) {
  const enrichedCategories = currentPage[0].categories
    .map((id) => {
      const cat = categories.find((cat) => cat.id === id);
      return cat
        ? {
            ...cat,
            path: `/category/${cat.slug}` // updated path to /category/.. rather than /categories/..
          }
        : null;
    })
    .filter(Boolean);

  currentPage[0].categories = enrichedCategories;
}
</script>

<style lang="scss" scoped>
 .visually-hidden {
    position: absolute !important;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px, 1px, 1px, 1px);
    white-space: nowrap;
  }

.blog-container {
  .blog-post-header {
    border-bottom: 1px solid $black;
    text-align: center;
    border-bottom: 1px solid $black;
    font-family: $font_didot_regular;
    font-style: italic;
    letter-spacing: -4px;
    text-transform: uppercase;
    padding: 15px 0;

    h1 {
      font-size: 80px;
      font-style: italic;
      line-height: 132px;
      margin-bottom: -20px;
    }

    @media only screen and (max-width: 580px) {
      padding: 0px 0 15px;
      h1 {
        font-size: 50px;
      }
    }
  }

  .blog-content {
    contain: content;
    background-color: $white;
    border-left: 1px solid $black;
    border-right: 1px solid $black;

    @media only screen and (max-width: 1024px) {
      border: none;
    }
  }
}
</style>